import type * as React from "react"

const Discord = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path d="m9.8 3-.4.7a9 9 0 0 0-2.8 0c0-.3-.2-.5-.3-.7-.9.1-1.7.4-2.5.8-1.5 2-2.1 4.6-1.9 7.1 1 .7 2 1.3 3.1 1.6l.7-1a6 6 0 0 1-1-.6l.2-.2a7.2 7.2 0 0 0 6.2 0l.3.2-1 .5c.1.4.4.8.6 1.1a10 10 0 0 0 3.1-1.6c.3-2.5-.4-5-1.8-7-.8-.5-1.7-.7-2.5-.9ZM6 9.5a1.2 1.2 0 0 1-1.1-1.3 1.2 1.2 0 0 1 1-1.2 1.2 1.2 0 0 1 1.2 1.2A1.2 1.2 0 0 1 6 9.5Zm4 0a1.2 1.2 0 0 1-1-1.3A1.2 1.2 0 0 1 10 7a1.2 1.2 0 0 1 1.2 1.2A1.2 1.2 0 0 1 10 9.5Z" />
  </svg>
)

export default Discord
